import { useBody } from "./body"
import { CardIndicatorProgress } from "../../components/cardIndicatorProgress"

const BestStoresByStoreRole = () => {
  const { data, loading, getData } = useBody()
  return <CardIndicatorProgress data={data} loading={loading} refresh={getData} title="Top 5 de las unidades asociadas" />
}

export { BestStoresByStoreRole }